/* ==========================================================================
   PIELLE 2.0 · assets/pielle-orbit.js
   Módulo de activos: producto al centro, ingredientes conectados por líneas
   y panel con el detalle. Sin autoplay y sin flechas: sólo click/tap.
   Reutiliza el contenido que ya existe en el bloque: no se escribe ni se
   altera una sola palabra.

   10/09/2026 — dos cambios pedidos por Facu sobre la captura de mobile:
   · Los pines decían 01 / 02 / 03 en la HOME. Ese bloque arma cada activo
     como <div><b>Nombre</b><span>detalle</span></div>, sin h3 ni h4, así que
     el selector viejo ("h4, h3") no encontraba nada y caía al número de
     índice. Ahora busca en cascada y, si tampoco hay, usa la primera línea
     de texto de la tarjeta. Un número ya no puede terminar de etiqueta.
   · Fuera el contador 01/0N del panel. El nombre del activo ya está en la
     tarjeta; el número era ruido.

   Se carga ANTES de pielle-ux.js y decide quién renderiza qué: marca con
   data-plx-ready los bloques que pielle-ux.js NO debe convertir.

   Acá viven también los dos centinelas de viewport (header compacto y
   convivencia de flotantes con el footer), porque necesitan correr temprano
   y tener un único dueño.
   ========================================================================== */
(function () {
  'use strict';

  /* --------------------------------------------------------------------
     FOTO DEL PRODUCTO AL CENTRO
     Render del envase nuevo, PNG transparente de 800 px (collar blanco
     acanalado, vidrio transparente, sérum rosa, cero metal).
     Si se vacía esta constante el módulo NO deja un agujero: colapsa la
     media y muestra los activos en rejilla.
     -------------------------------------------------------------------- */
  var PROD = 'https://cdn.shopify.com/s/files/1/0779/8711/9151/files/Diseno-sin-titulo-_2.webp?v=1788988083&width=800';

  var POS = ['top', 'right', 'bottom', 'left'];

  function mk(t, c, h) {
    var e = document.createElement(t);
    if (c) e.className = c;
    if (h != null) e.innerHTML = h;
    return e;
  }

  /* Nombre del activo. En cascada, de lo más explícito a lo más general:
     título real → destacado en negrita → primera línea de texto de la card. */
  function labelOf(card) {
    var sels = ['h2', 'h3', 'h4', 'h5', 'b', 'strong', '.pp4__t', '.plorb__name'];
    for (var i = 0; i < sels.length; i++) {
      var n = card.querySelector(sels[i]);
      var t = n && (n.textContent || '').trim();
      if (t) return t;
    }
    var raw = (card.textContent || '').trim();
    if (!raw) return '';
    var first = raw.split('\n')[0].trim();
    if (first.length > 34) first = first.slice(0, 34).replace(/\s+\S*$/, '');
    return first;
  }

  function wideHome(host) {
    var w = host.closest('.w') || host.closest('.wrap') || host.closest('.page-width');
    if (!w) return null;
    if (w.clientWidth > host.clientWidth * 1.25) return w;
    return null;
  }

  function build(host) {
    if (!host || host.dataset.orbReady) return;
    var cards = Array.prototype.filter.call(host.children, function (n) { return n.nodeType === 1; });
    if (cards.length < 2) return;
    host.dataset.orbReady = '1';
    host.classList.add('plorb-host');

    var hasProd = !!(PROD && PROD.trim());
    var box = mk('div', 'plorb' + (hasProd ? '' : ' plorb--noprod'));
    var stage = mk('div', 'plorb__stage');
    var panel = mk('div', 'plorb__panel');
    var body = mk('div', 'plorb__body');
    var dots = mk('div', 'plorb__dots');
    panel.appendChild(body); panel.appendChild(dots);

    if (hasProd) {
      var ring = mk('div', 'plorb__ring');
      var ring2 = mk('div', 'plorb__ring plorb__ring--in');
      var media = mk('div', 'plorb__media');
      var img = new Image();
      img.src = PROD;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.loading = 'lazy';
      img.decoding = 'async';
      img.className = 'plorb__prod';
      media.appendChild(img);
      stage.appendChild(ring); stage.appendChild(ring2); stage.appendChild(media);
    }

    var pins = [], panes = [], dotEls = [];

    cards.forEach(function (card, i) {
      var name = labelOf(card);

      var pin = mk('button', 'plorb__pin plorb__pin--' + (POS[i] || 'top'));
      pin.type = 'button';
      pin.setAttribute('aria-pressed', 'false');
      pin.appendChild(mk('span', 'plorb__pin-d'));
      pin.appendChild(mk('span', 'plorb__pin-t', '')).textContent = name;
      if (hasProd) pin.appendChild(mk('span', 'plorb__line'));
      stage.appendChild(pin);

      var pane = mk('div', 'plorb__pane');
      var thumb = card.querySelector(':scope > img');
      if (thumb) thumb.classList.add('plorb-hidden');
      pane.appendChild(card);
      body.appendChild(pane);

      var d = mk('button', 'plorb__dot');
      d.type = 'button';
      d.setAttribute('aria-label', name || String(i + 1));
      dots.appendChild(d);

      pins.push(pin); panes.push(pane); dotEls.push(d);
      pin.addEventListener('click', function () { go(i); });
      d.addEventListener('click', function () { go(i); });
    });

    box.appendChild(stage); box.appendChild(panel);

    var wide = wideHome(host);
    if (wide) { wide.appendChild(box); host.classList.add('plorb-host--moved'); }
    else { host.appendChild(box); }

    var cur = -1;
    function go(i) {
      if (i === cur) return;
      cur = i;
      pins.forEach(function (p, k) {
        p.classList.toggle('is-active', k === i);
        p.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      panes.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
      dotEls.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (window.PielleUX && window.PielleUX.sharpen) {
        try { window.PielleUX.sharpen(box); } catch (e) {}
      }
    }
    go(0);
  }

  /* --------------------------------------------------------------------
     HEADER COMPACTO
     No se puede confiar en window.scrollY: en este theme el scroll puede
     estar en <body> y no reportarse en window. Un centinela de 1 px al tope
     del documento resuelve el caso sin importar quién scrollea.
     -------------------------------------------------------------------- */
  function headerSentinel() {
    var root = document.documentElement;
    function set(on) { root.classList.toggle('pl-scrolled', !!on); }
    if ('IntersectionObserver' in window && document.body) {
      var s = document.getElementById('pl-sentinel');
      if (!s) {
        s = document.createElement('i');
        s.id = 'pl-sentinel';
        s.setAttribute('aria-hidden', 'true');
        s.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;opacity:0';
        document.body.insertBefore(s, document.body.firstChild);
      }
      new IntersectionObserver(function (es) { set(!es[0].isIntersecting); }, { threshold: 0 }).observe(s);
    }
    var last = null;
    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var on = y > 60;
      if (on === last) return;
      last = on;
      set(on);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  }

  /* --------------------------------------------------------------------
     FLOTANTES COORDINADOS
     Eran tres piezas independientes que se pisaban entre sí y le tapaban los
     medios de pago al footer: barra de compra, WhatsApp y volver-arriba.
     Acá hay una sola lógica: se publica la altura real de la barra en
     --pl-atc-h (el CSS apila los otros dos por encima) y cuando el footer
     entra al viewport la barra se va con una transición.
     -------------------------------------------------------------------- */
  function floatingStack() {
    var root = document.documentElement;
    var atc = document.querySelector('sticky-atc, .sticky-atc');
    var footer = document.querySelector('.footer, .plfb, #shopify-section-footer');
    var hidden = false;

    function measure() {
      if (!atc) { root.style.setProperty('--pl-atc-h', '0px'); return; }
      var cs = window.getComputedStyle(atc);
      var h = (cs.display === 'none' || hidden) ? 0 : Math.round(atc.getBoundingClientRect().height);
      root.style.setProperty('--pl-atc-h', h + 'px');
    }

    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        hidden = es[0].isIntersecting;
        root.classList.toggle('pl-footer-in', hidden);
        measure();
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' }).observe(footer);
    }

    measure();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);
    setTimeout(measure, 900);
    setTimeout(measure, 2600);
    if (window.ResizeObserver && atc) new ResizeObserver(measure).observe(atc);
  }

  /* bloques que pielle-ux.js ya no debe tocar */
  var OFF = '.roadmap-wrap, #ph .timelineCards, .pp4__companions, #ph .pdrnCompanions';

  function init(root) {
    root = root || document;
    root.querySelectorAll(OFF).forEach(function (h) { h.dataset.plxReady = '1'; });
    root.querySelectorAll('.pp4__companions, #ph .pdrnCompanions').forEach(function (h) {
      try { build(h); } catch (e) {}
    });
  }

  function boot() {
    init();
    try { headerSentinel(); } catch (e) {}
    try { floatingStack(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.PielleOrbit = { init: init };
})();
